export class FindConsumerResult {
    firstName: string = '';
    lastName: string = '';
    streetLine1: string = '';
    streetLine2: string = '';
    city: string = '';
    state: string = '';
    zip: string = '';
}